import { viewsTypes } from '../../types';

export const setView = data => ({
  type: viewsTypes.SET_VIEW,
  payload: { data }
});

export const toggleTimepad = value => ({
  type: viewsTypes.TOGGLE_TIMEPAD,
  value
});
